import React from 'react';
import styles from './SpecsModal.scss';
import classNames from 'classnames/bind';
import {FaTimes} from 'react-icons/fa'
import {Modal} from 'reactstrap';
import {
  TemperatureIcon,
  HumidityIcon,
  CO2Icon,
  ChemicalIcon,
  DustIcon
} from '../../atoms';
import awairDimensions from 'assets/images/awair/specs-awair-dimensions.jpg';

const cx = classNames.bind(styles);

const SpecsModal = ({
  modalShow,
  onHide,
  onToggle,
}) => {
  const sensorIconColor = '#A4AAB1';

  return (
    <Modal
      isOpen={modalShow}
      toggle={onToggle}
      size='lg'
      className={cx('specs-modal')}
    >
      <div className={cx('modal-header')}>
        <h2 className={cx('modal-title')}>仕様</h2>
        <button onClick={() => onHide()} className={cx('close')}>
          <span aria-hidden='true'><FaTimes /></span>
        </button>
      </div>
      <div className={cx('modal-body')}>
        <div className={cx('awair-specs-dimensions')}>
          <h3>サイズ</h3>
          <img src={awairDimensions} alt='dimensions' />
        </div>
        <div className={cx('awair-specs-wrapper')}>
          <div className={cx('awair-specs-text')}>
            <div className={cx('awair-specs-sensors')}>
              <h3>センサー</h3>
              <div>
                <TemperatureIcon
                  color={sensorIconColor}
                />
                <h4>温度</h4>
                <p>-40 to 125° C +/- 0.3° C (-40 to 257° F)</p>
              </div>
              <div>
                <HumidityIcon
                  color={sensorIconColor}
                />
                <h4>湿度</h4>
                <p>0 to 95% +/- 3%</p>
              </div>
              <div>
                <CO2Icon
                  color={sensorIconColor}
                />
                <h4><span lang='en-regular'>CO</span><sub>2</sub></h4>
                <p>0 to 4000 ppm +/- 75ppm</p>
              </div>
              <div>
                <ChemicalIcon
                  color={sensorIconColor}
                />
                <h4>ホコリ</h4>
                <p>0 to 2014 ppb</p>
              </div>
              <div>
                <DustIcon
                  color={sensorIconColor}
                />
                <h4 lang='en-regular'>VOCs</h4>
                <p>0 to 500 μg/m<sup>3</sup></p>
              </div>
            </div>
          </div>
          <div className={cx('awair-specs-text')}>
            <div className={cx('awair-specs-reqs')}>
              <h3>システム条件</h3>
              <p><span lang='en-thin'>Wi-Fi</span>環境</p>
              <p><span lang='en-thin'>iOS</span> 8以降もしくは<span lang='en-thin'>Android</span> 4以降を搭載したスマートフォンまたはタブレット</p>
              <p>無料<span lang='en-thin'>Awair</span>アカウント</p>
            </div>
            <div className={cx('awair-specs-wireless')}>
              <h3>無線通信</h3>
              <p>対応Wi-Fi 接続環境: 802.11 b/g/n @ 2.4GHz</p>
              <p><span lang='en-thin'>Bluetooth</span> 4.0</p>
            </div>
            <div className={cx('awair-specs-power')}>
              <h3>充電</h3>
              <p>100~125V AC, 50/60Hz, 最大14A, 1800W</p>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default SpecsModal;


// WEBPACK FOOTER //
// ./src/app/components/organisms/SpecsModal/SpecsModal.js